import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { DatabaseEvent } from './database-event.interface';

@Injectable({
    providedIn: 'root',
})
export class DatabaseStateService {
    private bus = new Subject<DatabaseEvent>();
    constructor() {}

    public emitEvent(event: DatabaseEvent) {
        this.bus.next(event);
    }

    public get event$() {
        return this.bus.asObservable();
    }
}
